"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTTI_Location_HoursOfOperation = void 0;
var t = __importStar(require("io-ts"));
var RTTI_Extension_1 = require("./RTTI_Extension");
var RTTI_code_1 = require("../Scalar/RTTI_code");
var RTTI_Element_1 = require("./RTTI_Element");
var RTTI_time_1 = require("../Scalar/RTTI_time");
exports.RTTI_Location_HoursOfOperation = t.recursion('ILocation_HoursOfOperation', function () {
    return t.partial({
        id: t.string,
        extension: t.array(RTTI_Extension_1.RTTI_Extension),
        modifierExtension: t.array(RTTI_Extension_1.RTTI_Extension),
        daysOfWeek: t.array(RTTI_code_1.RTTI_code),
        _daysOfWeek: t.array(RTTI_Element_1.RTTI_Element),
        allDay: t.boolean,
        _allDay: RTTI_Element_1.RTTI_Element,
        openingTime: RTTI_time_1.RTTI_time,
        _openingTime: RTTI_Element_1.RTTI_Element,
        closingTime: RTTI_time_1.RTTI_time,
        _closingTime: RTTI_Element_1.RTTI_Element
    });
});
//# sourceMappingURL=RTTI_Location_HoursOfOperation.js.map